import { useState, useEffect, useCallback } from "react";
import { getLoggedInUser, loginWithFacebookToken } from "../../library/user";

const initializeFb = () =>
  // eslint-disable-next-line no-unused-vars
  new Promise((resolve, _reject) => {
    if (typeof FB !== "undefined") {
      resolve();
    } else {
      // eslint-disable-next-line func-names
      window.fbAsyncInit = function () {
        // eslint-disable-next-line no-undef
        FB.init({
          appId: "439271813711980",
          cookie: true,
          xfbml: true,
          version: "v2.8",
        });
        // eslint-disable-next-line no-undef
        FB.AppEvents.logPageView();
        resolve();
      };

      // eslint-disable-next-line func-names
      (function (d, s, id) {
        let js;
        const fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        // eslint-disable-next-line prefer-const
        js = d.createElement(s);
        js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    }
  });

export const useFacebook = () => {
  const [fb, setFB] = useState([]);
  const [isReady, setReady] = useState(false);

  const initFacebook = useCallback(async () => {
    await initializeFb();
    // eslint-disable-next-line no-undef
    if (typeof FB !== "undefined") {
      // eslint-disable-next-line no-undef
      setFB(FB);
      setReady(true);
    }
  });

  useEffect(() => {
    initFacebook();
  }, [initFacebook]);

  return [fb, isReady];
};

export const loginFB = (FB, afterLogin) => {
  // FB.getLoginStatus(function (response) {
  //   // statusChangeCallback(response);
  //   console.log("response :>> ", response);
  // });
  FB.login(function (response) {
    let token;
    if (response.authResponse) {
      // FB.api("/me", "get", { fields: "id,name,email" }, function (response) {
      //   console.log("Good to see you, " + response);
      // });
      token = response.authResponse.accessToken;
      let resp;
      (async () => {
        resp = await loginWithFacebookToken(token);
        if (resp) {
          const user = await getLoggedInUser();
          // setUser(user);
          afterLogin(user);
          return user;
        }
      })();
    } else {
      console.log("User cancelled login or did not fully authorize.");
      token = false;
    }
    // return token;
  });
};
